import { classes } from '@theme/constants';
import { fetchConfig } from '@theme/fetch';
import { HTMLCustomElement } from '@theme/html-custom-element';

class NewsletterHero extends HTMLCustomElement {
  requiredAttributes = ['klaviyo-public-api-key', 'klaviyo-list'];

  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    this.on('submit', this.refs.form, this.handleFormSubmit.bind(this));
  }

  /**
   * @param {SubmitEvent} event
   */
  async handleFormSubmit(event) {
    const body = new FormData(event.target);

    event.preventDefault();

    this.refs.success.classList.add(classes.hidden);
    this.refs.error.classList.add(classes.hidden);

    if (!this.hasAttribute('klaviyo-public-api-key') || !this.hasAttribute('klaviyo-list')) return;

    const { ok } = await fetch(
      `https://a.klaviyo.com/client/subscriptions?company_id=${this.getAttribute('klaviyo-public-api-key')}`,
      fetchConfig('json', {
        headers: {
          revision: '2025-10-15',
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: body.get('email'),
                    first_name: body.get('first_name'),
                    last_name: body.get('last_name'),
                    locale: `${window.Shopify.locale}-${window.Shopify.country}`,
                    properties: {
                      $preferred_house: body.get('preferred_house'),
                      $preferred_category: body.get('preferred_category'),
                    },
                  },
                },
              },
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: this.getAttribute('klaviyo-list'),
                },
              },
            },
          },
        }),
      }),
    );

    if (ok) {
      this.refs.success.classList.remove(classes.hidden);
      this.refs.error.classList.add(classes.hidden);
      this.refs.formGroup.classList.add(classes.hidden);
      this.refs.form.reset();
      return;
    }

    this.refs.success.classList.add(classes.hidden);
    this.refs.error.classList.remove(classes.hidden);
    this.refs.formGroup.classList.remove(classes.hidden);
  }
}

if (!customElements.get('newsletter-hero')) customElements.define('newsletter-hero', NewsletterHero);
